/**
 * * Модель запроса на получение пользователя по Id
 */
export class GetByIdRequestModel {
  /**
   * * Номер пользователя
   */
  UserId!: number;
  constructor(obj?: Partial<GetByIdRequestModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
